export default __webpack_public_path__ + "static/cloud-e27b74b5eba287f34e0af0738ad95324.png";